// extracted by mini-css-extract-plugin
export var alignLeft = "r_qK d_bC";
export var alignCenter = "r_bL d_bz";
export var alignRight = "r_qL d_bD";
export var embedInnerWrapperDesign1 = "r_qM d_bJ";
export var embed = "r_qN d_bY";
export var titleMargin = "r_qP d_cs d_ds";
export var subtitleMargin = "r_qQ d_cp d_ds";
export var paragraphMargin = "r_qR d_cs d_ds";